import { BasicRequestsView } from "@/components/aicheck/BasicRequestsView";
import type { ActiveTab } from "@/components/aicheck/hooks/useTraceabilityHistory";
import type {
  AICheckRunResult,
  TraceabilityHistoryState,
} from "@/types/aicheck";

interface BasicRequestsTabProps {
  result: AICheckRunResult;
  activeTab: ActiveTab;
  showExecutiveSummary: boolean;
  onJumpToTab: (tab: ActiveTab) => void;
  onTraceabilityHistoryPush: (state: TraceabilityHistoryState) => void;
  onReturnToSummary: (findingIndex: number) => void;
  onProjectDataReferenceClick: (source: string) => void;
  /** 案件ページ埋め込み(project)では履歴タブが無いため undefined を渡す */
  onJumpToHistory?: () => void;
}

/** 「Basic Requests」タブ本体。tabpanel ラッパ + BasicRequestsView。 */
export function BasicRequestsTab({
  result,
  activeTab,
  showExecutiveSummary,
  onJumpToTab,
  onTraceabilityHistoryPush,
  onReturnToSummary,
  onProjectDataReferenceClick,
  onJumpToHistory,
}: BasicRequestsTabProps) {
  return (
    <div
      id="results-panel-basic"
      role="tabpanel"
      aria-labelledby="results-tab-basic"
      hidden={activeTab !== "basic"}
    >
      <BasicRequestsView
        result={result}
        showExecutiveSummary={showExecutiveSummary}
        onJumpToTab={onJumpToTab}
        onTraceabilityHistoryPush={onTraceabilityHistoryPush}
        onReturnToSummary={onReturnToSummary}
        onProjectDataReferenceClick={onProjectDataReferenceClick}
        onJumpToHistory={onJumpToHistory}
      />
    </div>
  );
}
